'use client';

import { Eye, EyeOff, KeyRound } from 'lucide-react';
import { useState } from 'react';

/** Password input with a show/hide toggle — the only client piece of sign-in. */
export function PasswordField({ className }: { className: string }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <KeyRound
        size={15}
        aria-hidden
        className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--color-faint)]"
      />
      <input
        id="password"
        name="password"
        type={shown ? 'text' : 'password'}
        required
        autoComplete="current-password"
        minLength={8}
        placeholder="Your password"
        className={`${className} pr-11`}
      />
      <button
        type="button"
        onClick={() => setShown((v) => !v)}
        aria-label={shown ? 'Hide password' : 'Show password'}
        className="absolute inset-y-0 right-0 grid w-11 place-items-center text-[var(--color-faint)] transition-colors hover:text-[var(--color-text)]"
      >
        {shown ? <EyeOff size={16} aria-hidden /> : <Eye size={16} aria-hidden />}
      </button>
    </div>
  );
}
